import React, { Component } from "react";
import { CircularProgress } from "@material-ui/core";

export default class BetterCircularProgress extends Component {
	render() {
		return (
			<>
				{this.props.loading ? (
					<div style={{ textAlign: "center" }}>
						<div style={{ marginTop: "25dvh", marginBottom: "25dvh" }}>
							<CircularProgress color="inherit" style={{ color: "#B388FF" }} size={50} />
						</div>
					</div>
				) : (
					this.props.children
				)}
			</>
		);
	}
}
